import { Optional } from "common/utils/types";

import Banner from "client/common/components/content/Banner";

import { IProductItem } from "../types";

type ProductLineWarningsProps = { item: Optional<IProductItem> };

const ProductLineWarnings = ({ item }: ProductLineWarningsProps) => {
  if (!item) {
    return null;
  }

  const warnings = [
    {
      label: "State Restriction",
      description: item.client_state_restriction_message,
      isVisible: !!item.client_state_restriction_message,
    },
  ].filter((warning) => warning.isVisible);

  return (
    <>
      {warnings.map((warning) => (
        <Banner key={warning.label}>
          <Banner.Content label={warning.label} description={warning.description} />
        </Banner>
      ))}
    </>
  );
};

export default ProductLineWarnings;
